import { render, staticRenderFns } from "./numberBorderTemp.vue?vue&type=template&id=5d2c9474&scoped=true&"
import script from "./numberBorderTemp.vue?vue&type=script&lang=js&"
export * from "./numberBorderTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c9474",
  null
  
)

export default component.exports